$(document).ready(function() {
  $('.testimonial-slider').slick({
    infinite: true,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 1,
    variableWidth: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 766,
        settings: {
          centerPadding: '20px',
          variableWidth: false,
          slidesToShow: 1
        }
      }
    ]
  });
});